import { useMemo } from "react";

import { useStateSelector } from "utils/field";
import { getUserDefinedWindowTypeWarning } from "utils/enclosure/predictUserDefinedWindowIssues";

export const useUserDefinedWindowTypeWarning = ({ accessor, modelCodes = {}, libCodes = {} }) => {
    const { codeRef = "" } = useStateSelector(`${accessor}.windowType`) || {};
    const widthMm = useStateSelector(`${accessor}.measurements.width`) || 0;
    const heightMm = useStateSelector(`${accessor}.measurements.height`) || 0;

    return useMemo(
        () =>
            getUserDefinedWindowTypeWarning({
                codeRef,
                code: modelCodes[codeRef] || libCodes[codeRef],
                widthMm: Number(widthMm),
                heightMm: Number(heightMm),
            }),
        [codeRef, modelCodes, libCodes, widthMm, heightMm]
    );
};
